import { useEffect, useRef } from "react";

export default function useRequestHistoryAutoRefresh(refresh, intervalMs = 5_000) {
    const refreshRef = useRef(refresh);

    useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);

    useEffect(() => {
        const refreshWhenVisible = () => {
            if (document.visibilityState === "visible") refreshRef.current();
        };
        const intervalId = window.setInterval(refreshWhenVisible, intervalMs);
        document.addEventListener("visibilitychange", refreshWhenVisible);
        window.addEventListener("focus", refreshWhenVisible);
        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", refreshWhenVisible);
            window.removeEventListener("focus", refreshWhenVisible);
        };
    }, [intervalMs]);
}
